import React, { Component , useState } from 'react';
import { Form, Button, Grid, Message } from 'semantic-ui-react';
import DatePicker , { registerLocale } from "react-datepicker";
import es from 'date-fns/locale/es';
import { estados } from './Estados.js'; 

registerLocale('es', es)
const server = `http://localhost:8080/api`;

export const DatePicketControl = ( {props , name , changeHandler}) => {

    const [startDate, setStartDate] = useState(new Date());
    
    return (
      <DatePicker 
            name = {name}
            selected={startDate}
            onChange={(date) => {
                setStartDate(date)
                changeHandler( date , name )
            }}
            locale="es"
            showYearDropdown
            dateFormatCalendar="MMMM"
            yearDropdownItemNumber={15}
            scrollableYearDropdown
        />
    );
}

export default class Filtro2 extends Component {
    constructor(props) {
      super(props);
      this.state = {
        fechaNotificacion: new Date(),
        fechaRecepcion: new Date(),
        errors: []
      };
      this._back = this._back.bind(this);
      this._validate = this._validate.bind(this);
      this._handlerChangeFechaFunction = this._handlerChangeFechaFunction.bind(this);
    }

    _addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }
  
    _validate(e) {
        let METHODNAME = '_validate - ';
        e.preventDefault();
        console.log(METHODNAME + 'INI');
        /*
        let maxFecha = this._addDays( this.state.fechaNotificacion , 5 );
        let recepcionEnFecha = maxFecha > this.state.fechaRecepcion;
        
        if( this.state.fechaNotificacion > this.state.fechaRecepcion ){
            this.setState({
                errors: ['La fecha de Notificación no puede ser anterior a la fecha de la Resolución.']
            });
        }else{
            console.log(METHODNAME + 'Recepcion de subsanacion es en fecha ? ', recepcionEnFecha );
            if ( recepcionEnFecha ) {
                this.props.next(estados.FILTRO_3);
            } else {
                this.props.next(estados.RECHAZADO);
            }
            this.props.saveForm({
              fechaNotificacion : this.state.fechaNotificacion,
              fechaRecepcion : this.state.fechaRecepcion,
              recepcionEnFecha : recepcionEnFecha
            });
        }*/

        this.sendFormFiltro02( this.state.fechaNotificacion, this.state.fechaRecepcion );

        console.log(METHODNAME + 'FIN');
    }
  
    _back() {
      this.props.back(estados.FILTRO_1)
    }

    _handlerChangeFechaFunction( date , name ){
        //console.log('change evento desde el METODO Fecha = ' + date + '; name = ' + name  );
        if( name === 'dtFecNotificacion'){
            this.setState({
                fechaNotificacion: date
            });
        }
        if( name === 'dtFecRecepcion'){
            this.setState({
                fechaRecepcion: date
            });
        }        
        //console.log('State.fechaResolucion = ' + this.state.fechaResolucion + '; State.fechaApelacion = ' + this.state.fechaApelacion );
    }

    componentDidMount() {
      let METHODNAME = 'componentDidMount - ';
      console.log(METHODNAME + 'INI');

      let url = server+`/interlocutoria/restForm02`;

      fetch(
        url , {
          method: 'GET',
          headers:{
              'Accept':'application/json',
              'Content-Type':'application/json'
          }
      })
      .then(res => res.json())
      .then(
          (result) => {

              console.log(METHODNAME + 'result = ' + result );
              console.log(METHODNAME + 'result = ' + result.result.items );
              console.log(METHODNAME + 'result = ' + result.result.nombreFiltro );

              this.setState({
                  isLoaded: true,
                  preguntas: result.result.items,
                  dataFiltro : result.result
              });
          },
          // Note: it's important to handle errors here
          // instead of a catch() block so that we don't swallow
          // exceptions from actual bugs in components.
          (error) => {
              console.log(METHODNAME + 'error = ' + error );
              this.setState({
                  isLoaded: true,
                  error
              });
          }
      )
      console.log(METHODNAME + 'FIN');
  }

    /**
     * https://github.com/anil-sidhu/react-17/tree/update-list
     * https://medium.com/@nutanbhogendrasharma/step-by-step-consume-rest-api-in-react-application-48388f6c4d9c
     * @param {*} fechaNotificacion 
     * @param {*} fechaRecepcion 
     * @param {*} recepcionEnFecha 
     */
     async sendFormFiltro02( fechaNotificacion, fechaRecepcion, recepcionEnFecha ) {
      let METHODNAME = 'sendFormFiltro02 - ';
      console.log(METHODNAME + 'INI');

      let dataForm ={
        fNotificacion : fechaNotificacion,
        fRecepcion : fechaRecepcion,
        recepcion : recepcionEnFecha
      }
      console.warn("item",dataForm);
      
      let analisisId = 1001 ;
      let url =  `http://localhost:8080/api/interlocutoria/restForm02/${analisisId}`;

      const json = await fetch( url , {
          method: 'POST',
          headers:{
              'Accept':'application/json',
              'Content-Type':'application/json'
          },
          body:JSON.stringify(dataForm)
      }).then((result) => {
          console.log(METHODNAME + 'analisar resultado.');
          result.json().then((resp) => {
              if( resp.result.resultado === 'APROBADO'){
                  this.props.next(estados.FILTRO_3);
              }else if(resp.result.resultado === 'RECHAZADO'){
                  this.props.next(estados.RECHAZADO);
              }else {
                  this.setState({
                      errors: ['Error enviado por el servicio: ' + resp.result.error  ]
                  });
              }
          })
      })
      return json ;
  }

    render() {

      const { error, isLoaded, preguntaActual } = this.state;

      if (error) {
        return <div>Error: {error.message}</div>;
      } else if (!isLoaded) {
        return <div>Loading...</div>;
      } else {
        return(
          <Form>
            
            { this.state.errors.length > 0 &&
            <Message negative>
              <p>{this.state.errors.join('. ')}</p>
            </Message>
            }
            
            <Form.Field>

              <h1>{preguntaActual.etapa.etapa}</h1>
              <h2>{preguntaActual.nombrePregunta}</h2>
              <h3>{preguntaActual.explicacionPregunta}</h3>
              
              {preguntaActual.tipoPregunta.idTipoPregunta===1 && 
                <Form.Group widths='equal'>
                    {preguntaActual.alternativas.map(item => (                  
                        item.tipoControl === 'date' &&
                        <Form.Field key={item.id} inline>
                            <label>{item.label}</label>
                            <DatePicketControl
                                id={item.id}
                                name={item.name}
                                changeHandler = {this._handlerChangeFechaFunction}
                            />
                        </Form.Field>
                    ))}
                </Form.Group>
              }

            </Form.Field>

            <Grid>
              <Grid.Column floated='left' width={5}>
                <Button secondary onClick={this._back}>Back</Button>
              </Grid.Column>
              <Grid.Column floated='right' width={5}>
                <Button primary onClick={this._validate}>Next</Button>
              </Grid.Column>
            </Grid>

          </Form>
        );
      }
      
    }
}
